import React from "react";
import "./Apropos.scss";

const Apropos = () => {
  return (
    <>
      <section className='Apropos top' id='apropos'>
        <div className='container'>
          <div className='heading'>
            <h4>À-PROPOS </h4>
            <h1>DE NOUS</h1>
          </div>


                <div className='button'>
                        <button className='btn_shadow'>
                        <h2>QUI SOMMES NOUS?</h2>
                        <p> 📈 <span>Aldôlo</span> est une start-up qui propose des services de qualité en matière d’intégration et de création des nouvelles technologies aux différentes structures locales et internationales.
                        </p>
                        <p>Nous accordons une haute importance à la qualité et à l’optimisation de vos produits,
                        c’est pourquoi nous proposons des solutions sur-mesure conformes à vos exigences particulières en
                        plus des solutions issues des partenaires experts de leur domaine avec qui nous oeuvrons.
                        La créativité et le professionalisme sont les fondements sur lesquels on se base pour livrer des produits à la hauteur de vos attentes et objectifs:
                        </p>
                        </button>
                </div>

                <div className='button'>
                        <button className='btn_shadow'>
                        <h2>👤NOTRE MÉTIER</h2>
                        <p> 📈Notre métier est de conseiller, d’orchestrer, d’optimiser et de
                            maintenir en condition opérationnelle le système d’information
                            des entreprises. Nos experts, certifiésdans les meilleures institutions informatiques au monde, vous accompagnent dans vos projets.
                        </p>
                        </button>
                </div>

                <div className='button'>
                        <button className='btn_shadow'>
                        <h2>UNE MAISON DE TRANSFORMATION CRÉATIVE !</h2>
                        <p>
                        Notre objectif est de créer des solutions numériques et innovantes de classes mondiales qui ouvrent de nouvelles opportunités de croissance et de transformation sociale  et commerciale tout au long du parcours client pour notre clientèle.
                        </p>
                        <p>Aldôlo est également à la recherche perpétuelle en termes de logiciels dédiés,  développement web, mobile, de e-commerce, de réseaux sociaux, de plateformes mobiles.</p>
                        </button>
                </div>
        </div>
      </section>
    </>
  )
}

export default Apropos;
